// Simple helpers for permission checks
export const hasPerm = (perms, code) => {
  if (!code) return false;
  if (!Array.isArray(perms)) return false;
  return perms.includes(code);
};

export const hasAny = (perms, required) => {
  if (!required) return false;
  const list = Array.isArray(required) ? required : [required];
  return list.some((c) => hasPerm(perms, c));
};
